import React, { useState, useEffect } from 'react'

import HeroSection from './Components/HeroSection/HeroSection'
import WhyWeTrading from './Components/WhyWeTrading/WhyWeTrading'
import EnterEmailSection from '../../Components/UIKit/EnterEmailSection/EnterEmailSection'
import TopFooter from '../../Components/UIKit/TopFooter/TopFooter'
import Loader from '../../Components/Advanced/Loader/Loader'
//
import { useLocation } from 'react-router-dom'
import getPageTitle from '../../Components/Advanced/Router/Utility'

// Style
import Style from './CopyTradingView'
import HowItWorks from './Components/HowItWorks/HowItWorks'
import Community from './Components/Community/Community'
const CopyTradingView = () => {
  const [loading, setLoading] = useState(true)
  const { pathname } = useLocation()

  if (loading) {
    document.body.style.overflow = 'hidden'
  } else {
    document.body.style.overflow = 'unset'
  }

  useEffect(() => {
    window.scrollTo(0, 0)
    document.title = getPageTitle(pathname)
    setTimeout(() => {
      setLoading(false)
    }, 2100)
  }, [])
  return (
    <>
      {loading && (
        <div>
          <Loader />
        </div>
      )}
      <HeroSection />
      <WhyWeTrading />
      <HowItWorks />
      <Community />
      {/* <EnterEmailSection /> */}
      <TopFooter />
    </>
  )
}

export default CopyTradingView
